import { UserRound } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { fmtDate, STATUS } from "@/lib/format";
import { LogoMark } from "./Logo";

const Field = ({ label, value, mono, testId }) => (
  <div>
    <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.16em] text-emerald-200/80">{label}</div>
    <div data-testid={testId} className={`text-white text-xs sm:text-sm font-semibold ${mono ? "font-mono" : ""}`}>{value}</div>
  </div>
);

export const GreenCard = ({ ap, demo = false }) => {
  const s = STATUS[ap.statut] || STATUS.sans_carte;
  const photo = fileUrl(ap.photo);
  return (
    <div data-testid="green-card" className="card-hover relative w-full max-w-[460px] aspect-[1.586/1] rounded-2xl overflow-hidden bg-gradient-to-br from-emerald-700 via-emerald-800 to-teal-900 shadow-[0_30px_60px_-20px_rgba(6,78,59,0.55)] transition-transform duration-500 hover:-translate-y-1 hover:rotate-[-0.5deg]">
      <div className="absolute inset-0 guilloche" />
      <div className="absolute inset-0 holo" />
      <div className="relative h-full p-4 sm:p-5 flex flex-col">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            <LogoMark className="h-7 w-7 sm:h-8 sm:w-8 !bg-white/15" />
            <div>
              <div className="font-display text-white font-extrabold tracking-tight text-sm sm:text-base leading-none">UAPHARCO</div>
              <div className="text-[9px] sm:text-[10px] text-emerald-200 uppercase tracking-[0.14em] mt-1">Carte verte professionnelle</div>
            </div>
          </div>
          <span className="rounded-full bg-white/90 px-2 py-0.5 text-[10px] font-bold text-emerald-900">{demo ? "SPÉCIMEN" : s.label.toUpperCase()}</span>
        </div>
        <div className="flex-1 flex items-center gap-3 sm:gap-4 mt-2">
          <div className="h-[72px] w-[60px] sm:h-[96px] sm:w-[78px] shrink-0 rounded-lg ring-2 ring-amber-200/70 bg-emerald-950/40 overflow-hidden grid place-items-center">
            {photo ? <img src={photo} alt="Photo AP" data-testid="green-card-photo" className="h-full w-full object-cover" /> : <UserRound className="h-8 w-8 text-emerald-200/60" />}
          </div>
          <div className="min-w-0 space-y-1.5">
            <div data-testid="green-card-name" className="font-display text-white font-bold text-sm sm:text-lg leading-tight truncate">{[ap.nom, ap.postnom].filter(Boolean).join(" ")}</div>
            <div className="text-emerald-100 text-xs sm:text-sm truncate">{ap.prenom}</div>
            <div className="text-[10px] uppercase tracking-[0.16em] text-emerald-200/80">Assistant(e) en pharmacie</div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 pt-2 border-t border-white/15">
          <Field label="N° CNAP" value={ap.cnap} mono testId="green-card-cnap" />
          <Field label="Délivrée le" value={fmtDate(ap.date_delivrance)} testId="green-card-issued" />
          <Field label="Expire le" value={fmtDate(ap.date_expiration)} testId="green-card-expires" />
        </div>
      </div>
    </div>
  );
};
